import React from 'react';

import { Heading, Text, Accordion, className } from 'aplazame-design-system';
import { default as ButtonComponent } from 'aplazame-design-system/src/components/GatsbyTransitionButtonComponent';
import Container from '../../componentsV2/Container';

import style from './style.module.scss';
import colorStyle from 'aplazame-design-system/src/scss/color.module.scss';
import sectionStyle from 'aplazame-design-system/src/scss/section.module.scss';
import transitionStyle from 'aplazame-design-system/src/scss/transitions.module.scss';

const FaqAccordion = ({ questions, stlyeFaq }) => (
    <Accordion
        initialShow={null}
        itemClassName={className(style.item).className}
        titleClassName={className(`h4 stylefaq ${style.question}`).className}
        items={questions.map((q) => ({
            title: q.question,
            body: (
                <Text
                    className={`body stylefaq ${style.answer} ${style[stlyeFaq]} ${transitionStyle['child-link-underline']}`}
                    tag="div"
                >
                    {q.answer}
                </Text>
            ),
        }))}
    />
);

export default function FaqSection({
    title,
    colorScheme,
    questions,
    buttons,
    nextSectionType,
}) {
    colorScheme = colorScheme?.toLowerCase();
    if (colorScheme === 'quaternary') {
        colorScheme = 'none';
    }
    const hasColorScheme = colorScheme !== 'none';

    let styleFaq = '';
    switch (colorScheme) {
        case 'primary':
            styleFaq = 'primary';
            break;
        case 'secondary':
            styleFaq = 'secondary';
            break;
        case 'none':
            styleFaq = 'none';
            break;
        default:
            styleFaq = 'none';
    }

    return (
        <section
            {...className(
                hasColorScheme
                    ? colorStyle[`bg-${colorScheme + 'Faq'}`]
                    : [colorStyle['bg-black']].join(' ')
            )}
        >
            {hasColorScheme ? (
                <div
                    data-sal="fade"
                    data-sal-easing="ease-out-quart"
                    className={`${sectionStyle.bg} ${colorStyle.bg}`}
                />
            ) : null}
            <Container>
                <div className={style.wrapper}>
                    <Heading
                        tag="h4"
                        className={`${style.heading} ${style[styleFaq]}`}
                        data-sal="slide-up"
                        data-sal-easing="ease-out-quart"
                    >
                        {title}
                    </Heading>
                    <FaqAccordion styleFaq={styleFaq} questions={questions} />

                    {buttons && buttons.length ? (
                        <ButtonComponent
                            focusWhite={styleFaq == 'none' ? true : false}
                            buttonClassName={style.button}
                            blockMobile={true}
                            buttons={buttons}
                        />
                    ) : null}
                </div>
            </Container>
        </section>
    );
}
